(function(angular){
	'use strict';
	
	var reitElementContainerObject = {
		templateUrl: [
			'STATIC_BASE_PATH', 
			templateUrlFunction
		],
		bindings: {
			reitElements: '<',
			selected: '@?',
			gridCols: '@?',
			sortByOption: '@'
		},
		controller: [
			'$filter',
			'$scope',
			'$timeout',
			'mixpanelFactory',
			ReitElementContainerFunction
		],
		controllerAs: 'reitElementContainer'
	};
	
	angular
		.module('reitElementListingModule')
		.component('reitElementContainer', reitElementContainerObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/reit-element-container/reit-element-container.html';
	}
	
	function ReitElementContainerFunction(
		$filter, 
		$scope, 
		$timeout, 
		mixpanelFactory
	){
		var reitElementContainer = this;
		var initialized = false;

		reitElementContainer.$onInit = function() {
			reitElementContainer.sortOptions = [{
				label: 'Recently acquired',
				value: 'acquisitionDate',
				sortDesc: true,
				conversionFunction: function(dateString) {
					return new Date(dateString);
				}
			}, {
				label: 'Debt assets first',
				value: 'structure',
				sortDesc: false
			}, {
				label: 'Equity assets first',
				value: 'structure',
				sortDesc: true
			}, {
				label: 'Risk rating',
				value: 'riskScore',
				sortDesc: false
			}];

			reitElementContainer.currentView = reitElementContainer.selected || 'grid';
			
			if(reitElementContainer.currentView === 'map') {
				$timeout(function() {
					$scope.$broadcast('reitElementDiversificationMap:showMap');
				}, 100);
			}

			reitElementContainer.gridCols = reitElementContainer.gridCols || '4';
			reitElementContainer.sortedBy = $filter('filter')(reitElementContainer.sortOptions, {'value': reitElementContainer.sortByOption}, true)[0] ||
				reitElementContainer.sortOptions[0];

			initialized = true;
			reitElementContainer.updateFilters();
		};

		reitElementContainer.$onChanges = function(changeObj) {
			if(initialized) {
				reitElementContainer.updateFilters();
			}
		};

		reitElementContainer.showList = function() {
			reitElementContainer.currentView = 'list';
			trackChange();
		};

		reitElementContainer.showGrid = function() {
			reitElementContainer.currentView = 'grid';
			trackChange();
		};

		reitElementContainer.showMap = function() {
			reitElementContainer.currentView = 'map';
			trackChange();
			$scope.$broadcast('reitElementDiversificationMap:showMap');
		};

		function trackChange() {
			mixpanelFactory.track('Change Property Container View', {
				view: reitElementContainer.currentView
			});
		}

		reitElementContainer.updateFilters = function() {
			if(angular.isUndefined(reitElementContainer.reitElements) || reitElementContainer.reitElements.length === 0) {
				return;
			}

			reitElementContainer.reitElements.active = orderProperties(reitElementContainer.reitElements.active);
			reitElementContainer.reitElements.redeemed = orderProperties(reitElementContainer.reitElements.redeemed);
			reitElementContainer.activeAndRedeemedProperties = reitElementContainer.reitElements.active.concat(reitElementContainer.reitElements.redeemed);

			reitElementContainer.hasBlendedReturnProjections = false;

			angular.forEach(reitElementContainer.reitElements, function(element) {
				if(element.blendedReturnProjection === true) {
					reitElementContainer.hasBlendedReturnProjections = true;
				}
			});

			$timeout(function() { $scope.$broadcast('runLazyLoad'); });
		};
		
		function orderProperties(reitElements){
			return $filter('orderBy')(reitElements, reitElementContainer.sortedBy.value, reitElementContainer.sortedBy.sortDesc, function(value1, value2) {
				if(reitElementContainer.sortedBy.conversionFunction) {
					value1 = reitElementContainer.sortedBy.conversionFunction(value1.value);
					value2 = reitElementContainer.sortedBy.conversionFunction(value2.value);
				} else {
					value1 = value1.value;
					value2 = value2.value;
				}
				if(value1 > value2) {
					return 1;
				} else if (value1 < value2) {
					return -1;
				} else {
					return 0;
				}
			});
		}
	}
})(window.angular);